import { render, staticRenderFns } from "./LiveChatDialogV2.vue?vue&type=template&id=d22cc86a&scoped=true&"
import script from "./LiveChatDialogV2.vue?vue&type=script&lang=js&"
export * from "./LiveChatDialogV2.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatDialogV2.vue?vue&type=style&index=0&id=d22cc86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22cc86a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VExpandTransition,VIcon,VSwitch,VTextField})
